import errorResponseHandler from '@data/helpers/errorResponseHandler';
import authAxios from '@services/authAxios';

const fetchDC = async ({ queries }) => {
    try {
        const { data } = await authAxios({
            method: 'GET',
            url: `/api/v1/user/dc?${queries}`,
        });

        return data;
    } catch (error) {
        const errorMessage = errorResponseHandler(error);
        throw new Error(errorMessage);
    }
};

export default fetchDC;
